import React from "react";

const DocumentsIcon = ({
  width = "28",
  height = "29",
  active = false,
  activeColor = "#1D5AB9",
  inActiveColor = "#969998",
  color = active ? activeColor : inActiveColor,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M4.66675 5.11157C4.66675 3.66183 5.842 2.48657 7.29175 2.48657H12.4031C13.0993 2.48657 13.767 2.76313 14.2592 3.25542L19.6479 8.64408C20.1401 9.13635 20.4167 9.80403 20.4167 10.5002V20.2782C20.4167 21.7279 19.2414 22.9032 17.7917 22.9032H7.29175C5.842 22.9032 4.66675 21.7279 4.66675 20.2782V5.11157ZM7.29175 4.23657C6.8085 4.23657 6.41675 4.62833 6.41675 5.11157V20.2782C6.41675 20.7615 6.8085 21.1532 7.29175 21.1532H17.7917C18.275 21.1532 18.6667 20.7615 18.6667 20.2782V10.6504H14.8796C13.4299 10.6504 12.2546 9.4751 12.2546 8.02536V4.23657H7.29175ZM14.0046 5.47568V8.02536C14.0046 8.5086 14.3964 8.90036 14.8796 8.90036H17.4293L14.0046 5.47568ZM7.73381 24.0699C8.09416 25.0895 9.06649 25.8199 10.2094 25.8199H17.7928C20.8533 25.8199 23.3345 23.3389 23.3345 20.2782V13.417C23.3345 12.7207 23.0578 12.053 22.5656 11.5608L21.5845 10.5796V20.2782C21.5845 22.3723 19.8868 24.0699 17.7928 24.0699H7.73381Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default DocumentsIcon;
